import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const ErrorCard = ({ children }) => {
  return (
    <div className="mb-6 p-4 rounded-lg bg-red-50 border-l-4 border-red-400 flex items-center shadow-sm self-start">
      <FontAwesomeIcon 
        icon={faExclamationTriangle} 
        className="w-5 h-5 text-red-400 mr-3 flex-shrink-0" 
      />
      <div className="text-red-900">
        <span className="font-bold">Error:</span> {children || 'An unexpected error occurred. Please try again.'}
      </div>
    </div>
  );
};

export default ErrorCard;